import React, { useEffect, useState } from "react";
import "./recentActivity.scss";
import Transactions from "./Transactions/transactions";
import useGetTransactions from "../../hooks/recentActivity/useGetTransactions";
import Skeleton from "../Skeleton/skeleton";
import { useStore } from "../../store/useStore";
import OrdersMobile from "./Orders/ordersMobile";
import useGetOrders from "../../hooks/recentActivity/useGetOrders";
import {
  getMobileOperatingSystem,
  ingestData,
  isMobile,
} from "../../bridges/BridgeServices";
import { EVENTS } from "../../utils/constants";

const RecentActivity = () => {
  const {
    transactions,
    transactionLoading,
    transactionError,
    orders,
    ordersLoading,
    ordersError,
  } = useStore();
  const { setFetchNextTransactions } = useGetTransactions(
    Object.values(transactions).length === 0 &&
      !transactionLoading
  );
  const { setFetchNextOrders } = useGetOrders(
    orders.length === 0 && !ordersLoading
  );
  const [eventTriggered, setEventTriggered] = useState(
    false
  );

  useEffect(() => {
    if (
      (!eventTriggered &&
        !ordersLoading &&
        orders.length > 0) ||
      (!eventTriggered &&
        !transactionLoading &&
        Object.values(transactions).length > 0)
    ) {
      setEventTriggered(true);
      ingestData({
        name: EVENTS.HELP_ACTIVITY_SHOWN,
        data: {
          source: isMobile()
            ? getMobileOperatingSystem()
            : "WEB",
        },
      });
    }
  }, [transactionLoading, ordersLoading]);

  if (
    Object.values(transactions).length === 0 &&
    transactionLoading &&
    orders.length === 0 &&
    ordersLoading
  ) {
    return (
      <div className="recentActivityMain">
        <Skeleton
          height="24px"
          width="80px"
          variant="text"
          className="recentActivityTitle"
        />
        <Skeleton
          height="24px"
          variant="text"
          className="recentActivityTitle"
        />
        <Skeleton
          height="24px"
          variant="text"
          className="recentActivityTitle"
        />
        <Skeleton
          height="24px"
          variant="text"
          className="recentActivityTitle"
        />
        <Skeleton
          height="24px"
          variant="text"
          className="recentActivityTitle"
        />
      </div>
    );
  }

  return (
    (Object.values(transactions).length > 0 ||
      orders.length > 0) && (
      <div className="recentActivityMain">
        <div className="recentActivityTitle">
          Need help with recent activity?
        </div>
        <Transactions
          refetchData={() => setFetchNextTransactions(true)}
        />
        <OrdersMobile
          refetchData={() => setFetchNextOrders(true)}
        />
      </div>
    )
  );
};

export default RecentActivity;
